import * as React from 'react';
import { Tooltip } from '@mui/material';

interface Props {
  tooltipTitle: string;
  title: string;
  value: string | number | null | undefined;
}

export const StatBlock: React.FC<Props> = (props) => {
  const { tooltipTitle, title, value } = props;

  return (
    <Tooltip title={tooltipTitle}>
      <div className="text-center">
        <h6 className="font-light underline lg:text-base py-2 md:text-sm text-xs">{title}</h6>
        <p className="lg:text-xl md:text-lg text-base">{value || '-'}</p>
      </div>
    </Tooltip>
  );
};
StatBlock.displayName = 'PerDiemArchive.SmartPerDiem.StatBlock';
